export const getStep = (num: number): number => {
  const zeros = getZeros(num);
  const step =
    Math.round(num / (2 * Math.pow(10, zeros))) * Math.pow(10, zeros - 1);
  return step;
};

export const getZeros = (num: number): number => {
  let zeros = -1;

  do {
    num = num / 10;
    ++zeros;
  } while (num > 1);
  return zeros;
};
